module.exports = __webpack_public_path__ + "img/0db507b127cae923319268aa9e76dfdd.0db507b1.png";